interface Props {
  checked: boolean;
  primaryInnerColor?: boolean;
}
const SvgCheckBox: React.FC<Props> = ({ checked, primaryInnerColor }) => {
  return checked ? (
    <svg
      style={{ cursor: "pointer" }}
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14 1H2C1.44772 1 1 1.44772 1 2V14C1 14.5523 1.44772 15 2 15H14C14.5523 15 15 14.5523 15 14V2C15 1.44772 14.5523 1 14 1ZM2 0C0.895431 0 0 0.895431 0 2V14C0 15.1046 0.895431 16 2 16H14C15.1046 16 16 15.1046 16 14V2C16 0.895431 15.1046 0 14 0H2Z"
        className={`${primaryInnerColor ? "fill-primary-inner" : "fill-primary"} `}
      />
      <path
        d="M11.8485 5L6.82214 9.63691L4.14985 6.8948L3 8.07635L6.82214 12L13 6.18155L11.8485 5Z"
        className={`${primaryInnerColor ? "fill-primary-inner" : "fill-primary"} `}
      />
    </svg>
  ) : (
    <svg
      style={{ cursor: "pointer" }}
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14 1H2C1.44772 1 1 1.44772 1 2V14C1 14.5523 1.44772 15 2 15H14C14.5523 15 15 14.5523 15 14V2C15 1.44772 14.5523 1 14 1ZM2 0C0.895431 0 0 0.895431 0 2V14C0 15.1046 0.895431 16 2 16H14C15.1046 16 16 15.1046 16 14V2C16 0.895431 15.1046 0 14 0H2Z"
        className="fill-gray3"
      />
    </svg>
  );
};

export default SvgCheckBox;
